/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Syntax_Errors_S5_P1Inputs */

const en_guide_json_syntax_errors_s5_p1 = /** @type {(inputs: Guide_Json_Syntax_Errors_S5_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON only supports specific value types. Common mistakes include using <code>undefined</code>, <code>NaN</code>, <code>Infinity</code>, or functions: none of which are valid in JSON.`)
};

const ko_guide_json_syntax_errors_s5_p1 = /** @type {(inputs: Guide_Json_Syntax_Errors_S5_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON은 특정 값 타입만 지원합니다. 흔한 실수로는 <code>undefined</code>, <code>NaN</code>, <code>Infinity</code> 또는 함수를 사용하는 것이 있습니다: 이들 중 어느 것도 JSON에서 유효하지 않습니다.`)
};

const ja_guide_json_syntax_errors_s5_p1 = /** @type {(inputs: Guide_Json_Syntax_Errors_S5_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONは特定の値の型のみをサポートしています。よくある間違いには、<code>undefined</code>、<code>NaN</code>、<code>Infinity</code>、関数の使用があります: これらはいずれもJSONでは無効です。`)
};

/**
* | output |
* | --- |
* | "JSON only supports specific value types. Common mistakes include using <code>undefined</code>, <code>NaN</code>, <code>Infinity</code>, or functions: none of..." |
*
* @param {Guide_Json_Syntax_Errors_S5_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_syntax_errors_s5_p1 = /** @type {((inputs?: Guide_Json_Syntax_Errors_S5_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Syntax_Errors_S5_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_syntax_errors_s5_p1(inputs)
	if (locale === "ko") return ko_guide_json_syntax_errors_s5_p1(inputs)
	return ja_guide_json_syntax_errors_s5_p1(inputs)
});